export const UPDATE_ANCILLARIES = 'UPDATE_ANCILLARIES'

export const updateAncillaries = data => {
  return {
    type: UPDATE_ANCILLARIES,
    data,
  }
}
